import $ from "jquery";
import swal from "sweetalert";
import I18n from "i18n-js";

// $(document).on('turbolinks:load', function () {

    /*REGISTRATION FORM*/
    const regForm             = document.querySelector('form#pre-registration');
    const ticketForm          = document.querySelector('form#ticket-registration');

    const firstNameEl         = document.querySelector('#first_name');
    const lastNameEl          = document.querySelector('#last_name');
    const emailEl             = document.querySelector('#email');
    const phoneNumberEl       = document.querySelector('#phone_number');
    const productEl           = document.querySelector('#product');
    const productTypeEl       = document.querySelector('#product_type');
    const priceEl             = document.querySelector('#price');
    const ticketEl            = document.querySelector('#ticket_number');

    const eventEl             = document.querySelector('#event');
    const quantityEl          = document.querySelector('#quantity');
    const motherLastNameEl    = document.querySelector('#mother_last_name');
    const commentEl           = document.querySelector('#comment');

    /******************/

    const isRequired = value => value === '' ? false : true;

    const isEmailValid = (email) => {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    };

    const showError = (input, message) => {
        // get the form-field element
        const formField = input.closest('.form-group') || input.parentElement;

        formField.classList.remove('success');
        formField.classList.add('error');

        const error = formField.querySelector('small');
        if (error) {
            error.textContent = message;
        }
    };

    const showSuccess = (input) => {
        // get the form-field element
        const formField = input.closest('.form-group') || input.parentElement;
        //console.log(formField);
        // remove the error class
        formField.classList.remove('error');
        formField.classList.add('success');

        // hide the error message
        const error = formField.querySelector('small');
        if (error) {
            error.textContent = '';
        }
    };

    const checkName = () => {
        let valid = false;
        const firstName = firstNameEl.value.trim();

        if (!isRequired(firstName)) {
            showError(firstNameEl, 'Es necesario ingresar el nombre.');
        } else {
            showSuccess(firstNameEl);
            valid = true;
        }
        return valid;
    };

    const checkLastName = () => {
        let valid = false;
        const lastName = lastNameEl.value.trim();

        if (!isRequired(lastName)) {
            showError(lastNameEl, 'Es necesario ingresar el apellido paterno.');
        } else {
            showSuccess(lastNameEl);
            valid = true;
        }
        return valid;
    };

    const checkEmail = () => {
        let valid = false;
        const email = emailEl.value.trim();
        if (!isRequired(email)) {
            showError(emailEl, 'Es necesario ingresar un email.');
        } else if (!isEmailValid(email)) {
            showError(emailEl, 'Email es invalido.')
        } else {
            showSuccess(emailEl);
            valid = true;
        }
        return valid;
    };

    const checkPhoneNumber = () => {
        let valid = false;
        const phone = phoneNumberEl.value.trim();

        if (!isRequired(phone)) {
            showError(phoneNumberEl, 'Es necesario ingresar número de teléfono.');
        } else {
            showSuccess(phoneNumberEl);
            valid = true;
        }
        return valid;
    };

    const checkProduct = () => {
        let valid = false;
        const product = productEl.value.trim();

        if (!isRequired(product)) {
            showError(productEl, 'Es necesario ingresar el producto.');
        } else {
            showSuccess(productEl);
            valid = true;
        }
        return valid;
    };

    const checkProductType = () => {

        let valid = false;
        const product_type = productTypeEl.value.trim();

        if (!isRequired(product_type)) {
            showError(productTypeEl, 'Es necesario ingresar tipo.');
        } else {
            showSuccess(productTypeEl);
            valid = true;
        }
        return valid;
    };

    const checkPrice = () => {

        let valid = false;
        const price = priceEl.value.trim();

        if (!isRequired(price)) {
            showError(priceEl, 'Es necesario ingresar precio.');
        } else {
            showSuccess(priceEl);
            valid = true;
        }
        return valid;
    };

    const checkTicket = () => {

        let valid = false;
        const ticket = ticketEl.value.trim();

        if (!isRequired(ticket)) {
            showError(ticketEl, 'Es necesario ingresar tipo.');
        } else {
            showSuccess(ticketEl);
            valid = true;
        }
        return valid;
    };

    const checkEvent = () => {

        let valid = false;
        const event = eventEl.value.trim();

        if (!isRequired(event)) {
            showError(eventEl, 'Es necesario seleccionar evento.');
        } else {
            showSuccess(eventEl);
            valid = true;
        }
        return valid;
    };

    const checkQuantity = () => {

        let valid = false;
        const quantity = quantityEl.value.trim();

        if (!isRequired(quantity)) {
            showError(quantityEl, 'Es necesario ingresar cantidad.');
        } else {
            showSuccess(quantityEl);
            valid = true;
        }
        return valid;
    };

    const checkMotherName = () => {

        let valid = false;
        const mother_name = motherLastNameEl.value.trim();

        if (!isRequired(mother_name)) {
            showError(motherLastNameEl, 'Es necesario ingresar apellido materno.');
        } else {
            showSuccess(motherLastNameEl);
            valid = true;
        }
        return valid;
    };

    const checkComment = () => {

        // let valid = false;
        // const comment = commentEl.value.trim();
        //
        // if (!isRequired(comment)) {
        //     showError(commentEl, 'Es ingresar comentario.');
        // } else {
        //     showSuccess(commentEl);
        //     valid = true;
        // }
        // return valid;
        true
    };


    // Waits for user to pause typing before validate
    const debounce = (fn, delay = 500) => {
        let timeoutId;
        return (...args) => {
            // cancel the previous timer
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
            // setup a new timer
            timeoutId = setTimeout(() => {
                fn.apply(null, args)
            }, delay);
        };
    };

    if(regForm){
        regForm.addEventListener('input', debounce(function (e) {
            switch (e.target.id) {
                case 'first_name':
                    checkName();
                    break;
                case 'last_name':
                    checkLastName();
                    break;
                case 'phone':
                    checkPhoneNumber();
                    break;
                case 'email':
                    checkEmail();
                    break;
                case 'product':
                    checkProduct();
                    break;
                case 'product_type':
                    checkProductType();
                    break;
                case 'price':
                    checkPrice();
                    break;
                case 'ticket_number':
                    checkTicket();
                    break;
            }
        }));
    }

    /** REGISTRATION FORM **/
    $('#reg-submit').click(function(e){
        // validate forms
        if(!e.detail || e.detail == 1){
            let
                isNameValid = checkName(),
                isLastNameValid = checkLastName(),
                isPhoneValid = checkPhoneNumber(),
                isProductValid = checkProduct(),
                isProductTypeValid = checkProductType(),
                isPriceValid = checkPrice(),
                isTicketValid = checkTicket(),
                isEmailValid = checkEmail();

            let isFormValid = isNameValid && isLastNameValid && isProductValid && isProductTypeValid &&
                isPhoneValid && isPriceValid && isEmailValid && isTicketValid;

            if(isFormValid){
                console.log("isFormValid")
                swal({
                    title: 'CONFIRMAR REGISTRO',
                    icon: 'info',
                    text: '.',
                    buttons: {
                        cancel: I18n.t('messages.cancel'),
                        confirm: I18n.t('messages.confirm')
                    }
                }).then((isConfirmed) => {
                    if (isConfirmed) {
                        // Select the form element
                        var formReg = $('form#pre-registration');

                        // Bind a function to the submit event
                        formReg.submit(function(event) {
                            // Prevent the default form submission behavior
                            event.preventDefault();

                            swal({
                                title: "Enviando...",
                                text: "Por favor espera",
                                icon: "info",
                                //showConfirmButton: false,
                                buttons:           false,
                                allowOutsideClick: false
                            });

                            // Send an AJAX request to submit the form data
                            $.ajax({
                                url: formReg.attr('action'),
                                type: formReg.attr('method'),
                                data: formReg.serialize(),
                                success: function(response) {
                                    swal({
                                        title: "¡REGISTRO COMPLETADO!",
                                        text: ".",
                                        icon: 'success',
                                        confirmButtonText: 'Aceptar',
                                        showConfirmButton: true
                                    }).then(function() {
                                        window.location = "/";
                                    });
                                },
                                error: function(xhr, status, error) {
                                    let msj_error = ''
                                    if(xhr.responseText !== undefined || xhr.responseText !== '')
                                    {
                                        $.each(xhr.responseJSON, function(index, value) {
                                            msj_error += '' + index + ': ' + value + '\n'
                                        });
                                    }
                                    swal({
                                        title: "Hubo un error al registrar, intenta de nuevo...\n ",
                                        text: `${msj_error}`,
                                        icon: 'error',
                                        confirm: {
                                            text: "Aceptar",
                                            value: true,
                                            visible: true,
                                            className: "",
                                            closeModal: true
                                        }
                                    });
                                }
                            });
                        });

                        formReg.submit();
                    }
                }).catch(e.preventDefault());
            } else {
                console.log("isFormInnnvalid")
                swal({
                    title: "¡UPS!",
                    text: "Parece que aún hay campos por llenar, verifica tu información e intenta de nuevo.",
                    icon: 'warning',
                    confirm: {
                        text: "Aceptar 123",
                        value: true,
                        visible: true,
                        className: "",
                        closeModal: true
                    }
                });
            }
        }

    });

    if(ticketForm){
        ticketForm.addEventListener('input', debounce(function (e) {
            switch (e.target.id) {
                case 'event':
                    checkEvent();
                    break;
                case 'price':
                    checkPrice();
                    break;
                case 'quantity':
                    checkQuantity();
                    break;
                case 'last_name':
                    checkLastName();
                    break;
                case 'mother_last_name':
                    checkMotherName();
                    break;
                case 'name':
                    checkName();
                    break;
                case 'email':
                    checkEmail();
                    break;
                case 'phone':
                    checkPhoneNumber();
                    break;
                case 'comment':
                    checkComment();
                    break;
            }
        }));
    }

    $('#ticket-submit').click(function(e){
        // validate forms
        if(!e.detail || e.detail == 1){
            let
                isEventValid = checkEvent(),
                isPriceValid = checkPrice(),
                isQuantityValid = checkQuantity(),
                isLastNameValid = checkLastName(),
                isMLastNameValid = checkMotherName(),
                isNameValid = checkName(),
                isEmailValid = checkEmail(),
                isPhoneValid = checkPhoneNumber();

            let isFormValid = isEventValid && isPriceValid && isQuantityValid && isLastNameValid &&
                isMLastNameValid && isNameValid && isEmailValid && isPhoneValid;

            var authenticityToken = $('[name="csrf-token"]')[0] && $('[name="csrf-token"]')[0].content;

            if(isFormValid){
                console.log("isFormValid")
                swal({
                    title: 'CONFIRMAR REGISTRO',
                    icon: 'info',
                    text: '',
                    buttons: {
                        cancel: I18n.t('messages.cancel'),
                        confirm: I18n.t('messages.confirm')
                    }
                }).then((isConfirmed) => {
                    if (isConfirmed) {
                        // Select the form element
                        var formReg = $('form#ticket-registration');

                        // Bind a function to the submit event
                        formReg.submit(function(event) {
                            // Prevent the default form submission behavior
                            event.preventDefault();

                            swal({
                                title: "Enviando...",
                                text: "Por favor espera",
                                icon: "info",
                                //showConfirmButton: false,
                                buttons:           false,
                                allowOutsideClick: false
                            });

                            // Send an AJAX request to submit the form data
                            $.ajax({
                                url: formReg.attr('action'),
                                type: formReg.attr('method'),
                                data: {
                                    authenticity_token: authenticityToken,
                                    event_id: $("#event").val(),
                                    last_name: $("#last_name").val(),
                                    mother_last_name: $("#mother_last_name").val(),
                                    first_name: $("#first_name").val(),
                                    email: $("#email").val(),
                                    quantity: $("#quantity").val(),
                                    price: $("#price").val(),
                                    phone_number: $("#phone_number").val(),
                                    comment: $("#comment").val()
                                },
                                success: function(response) {
                                    console.log(response)
                                    if (response[0].Procede > 0) {
                                        window.location.replace("http://epagos.uach.mx/pagos/index?IdConcepto=" + $("#concept_id").val() + "&CuantasVariables=" + $("#quantity").val() + "&ImporteTotal=" + $("#price").val() + "&Facultad=" + $("#faculty").val() + "&IdGrupoConcepto=3&ManejaProrroga=0&Origen=BOLETOS&IdCliente=" + parseInt(response[0].IdCliente) + "&ApellidoPaterno=" + $("#last_name").val() + "&ApellidoMaterno=" + $("#mother_last_name").val() + "&Nombre=" + $("#first_name").val() + "&CorreoElectronico=" + $("#email").val() + "&Comentario=" + $("#comment").val() + "")
                                    } else {
                                        swal({
                                            title: "",
                                            text: response[0].Mensaje,
                                            icon: 'error',
                                            confirmButtonText: 'Aceptar',
                                            showConfirmButton: true
                                        }).then(function() {
                                            window.location = "/";
                                        });
                                    }
                                },
                                error: function(xhr, status, error) {
                                    let msj_error = ''
                                    if(xhr.responseText !== undefined || xhr.responseText !== '')
                                    {
                                        $.each(xhr.responseJSON, function(index, value) {
                                            msj_error += '' + index + ': ' + value + '\n'
                                        });
                                    }
                                    swal({
                                        title: "Hubo un error al registrar, intenta de nuevo...\n ",
                                        text: `${msj_error}`,
                                        icon: 'error',
                                        confirm: {
                                            text: "Aceptar",
                                            value: true,
                                            visible: true,
                                            className: "",
                                            closeModal: true
                                        }
                                    });
                                }
                            });
                        });

                        formReg.submit();
                    }
                }).catch(e.preventDefault());
            } else {
                console.log("isFormInnnvalid")
                swal({
                    title: "¡UPS!",
                    text: "Parece que aún hay campos por llenar, verifica tu información e intenta de nuevo.",
                    icon: 'warning',
                    confirm: {
                        text: "Aceptar",
                        value: true,
                        visible: true,
                        className: "",
                        closeModal: true
                    }
                });
            }
        }

    });
    /*******************************/
// });
